export const imageResolutions = [64, 128, 192, 512, 1024]
